import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=41c45c80&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c45c80"]])

export default __exports__